import { render, staticRenderFns } from "./CouponCodeDetail.vue?vue&type=template&id=246a5d5c&scoped=true&xmlns%3Adetail-list=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./CouponCodeDetail.vue?vue&type=script&lang=js"
export * from "./CouponCodeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a5d5c",
  null
  
)

export default component.exports